import React, { useMemo } from 'react';
import classnames from 'classnames';
import { isNull, max } from 'lodash/fp';

import styles from '../ReportDefinitions.module.scss';
import { OpenFieldSection } from '../../../../datasets/instances/store';
import { widthsByType } from '../../../../admin/dataset-builder/preview/tablePreview/TableHeader';
import { OpenFieldType, SingleDatasetField, TableDatasetFieldType } from '../../../../datasets/store';
import { InformationTooltip } from '../../../../shared/tooltip';
import { getReportTableDatasetField } from '../ReportDatasetFields';
import { useAppSelector } from '../../../../../hooks/react-redux';
import { getSearchFieldSection } from '../../store';

interface TableCellProps {
    field: SingleDatasetField;
    index: number;
    isFirstCell: boolean;
    datasetId: number;
    toggleSection: (fieldSection: OpenFieldSection) => void;
    getSectionOpen: (fieldSection: OpenFieldSection) => boolean;
}

export const TableCell: React.FC<TableCellProps> = ({ field, index, isFirstCell, datasetId, toggleSection, getSectionOpen }) => {
    const searchFieldSection = useAppSelector(getSearchFieldSection);
    const cellWidth = useMemo(() => `${max([widthsByType[field.type as TableDatasetFieldType], 150])}px`, [field.type]);
    const isSearchedField = useMemo(() => !isNull(searchFieldSection) && searchFieldSection.type === OpenFieldType.FIELD && searchFieldSection.fieldId === field.id, [searchFieldSection, field.id]);

    return (
        <div
            className={classnames(styles.cellWrapper, {
                [styles.firstCell]: isFirstCell,
                [styles.searchedFieldWrapper]: isSearchedField
            })}
            style={{ width: cellWidth, minWidth: cellWidth }}
            data-testid={`table-cell-${index}-wrapper`}
        >
            <div className={styles.openCellWrapper}>
                {getReportTableDatasetField(field, index, datasetId, toggleSection, getSectionOpen)}
                {field.settings.showClause && <InformationTooltip content='Add personalised clause label here' label='cl' />}
            </div>
        </div>
    );
};
